<template>
  <router-view />
</template>

<script>
export default {
  name: 'emptyLayout',
}
</script>
